export default __webpack_public_path__ + "static/media/chatbot.e14e315e.png";